import { z } from "zod";

// Base agent intent schema — all agent intents have type, payload, and timestamp
export const baseAgentIntentSchema = z.object({
  type: z.string(),
  payload: z.record(z.string(), z.unknown()).default({}),
  createdAt: z.string(),
});

export type BaseAgentIntent = z.infer<typeof baseAgentIntentSchema>;

// Brand intents — each brand action is its own intent type
const brandIntentTypes = [
  "logo_set",
  "social_links_saved",
  "images_associated",
] as const;

export type BrandIntentType = (typeof brandIntentTypes)[number];

export const brandAgentIntentSchema = z.object({
  type: z.enum(brandIntentTypes),
  payload: z.record(z.string(), z.unknown()).default({}),
  createdAt: z.string(),
});

export type BrandAgentIntent = z.infer<typeof brandAgentIntentSchema>;

// Union of all agent intent types
export const agentIntentSchema = z.union([
  brandAgentIntentSchema,
  baseAgentIntentSchema, // Fallback for unknown intents
]);

export type AgentIntent = z.infer<typeof agentIntentSchema>;

// Type guards
export function isBrandAgentIntent(intent: AgentIntent): intent is BrandAgentIntent {
  return brandIntentTypes.includes(intent.type as BrandIntentType);
}

// Factories
export const brandIntent = (type: BrandIntentType): BrandAgentIntent => ({
  type,
  payload: {},
  createdAt: new Date().toISOString(),
});
